/**
 * Single Services JavaScript
 * Handles tab switching for service pricing
 */

document.addEventListener("DOMContentLoaded", function () {
    // Get all tab buttons and content containers
    const tabButtons = document.querySelectorAll(".service-price .box__tags .tag[data-tab]");
    const contentContainers = document.querySelectorAll(".service-price .box__cards[data-content]");

    // Initialize - show only the active tab content on page load
    const activeTab = document.querySelector(".service-price .box__tags .tag.active");
    if (activeTab) {
        const activeTabType = activeTab.getAttribute("data-tab");
        contentContainers.forEach((content) => {
            if (content.getAttribute("data-content") === activeTabType) {
                content.style.display = "flex";
            } else {
                content.style.display = "none";
            }
        });
    }

    // Add click event listeners to tab buttons
    tabButtons.forEach((button) => {
        button.addEventListener("click", function () {
            const targetTab = this.getAttribute("data-tab");

            // Remove active class from all tabs and hide all content
            tabButtons.forEach((tab) => tab.classList.remove("active"));
            contentContainers.forEach((content) => {
                content.classList.remove("active");
                content.style.display = "none";
            });

            // Add active class to clicked tab
            this.classList.add("active");

            // Show corresponding content
            const targetContent = document.querySelector(`.service-price .box__cards[data-content="${targetTab}"]`);
            if (targetContent) {
                targetContent.classList.add("active");
                targetContent.style.display = "flex";
            }
        });
    });
});

// SwiperJS pro how it works slider
function initHowItWorksSwiper() {
    const swiperContainer = document.querySelector(".cards__swiper");
    const slides = document.querySelectorAll(".cards__swiper .swiper-slide");
    const navButtons = document.querySelector(".how-it-works .buttons");

    // Skryj navigační tlačítka pokud je 4 nebo méně karet
    if (slides.length <= 4 && navButtons) {
        navButtons.style.display = "none";
    }

    const howItWorksSwiper = new Swiper(".cards__swiper", {
        slidesPerView: "auto",
        spaceBetween: 8,
        loop: false,
        freeMode: true,
        navigation: {
            nextEl: ".buttons-works__next",
            prevEl: ".buttons-works__prev",
        },
        breakpoints: {
            768: {
                spaceBetween: 8,
                slidesPerView: "auto",
            },
            1024: {
                spaceBetween: 8,
                slidesPerView: "auto",
            },
        },
    });
}

// Inicializuj how it works swiper
if (document.querySelector(".cards__swiper")) {
    initHowItWorksSwiper();
}
